export default __webpack_public_path__ + "static/csharp-509c1a4773a41d73a664483a5afa6671.png";